import State from "ducks/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State, props) => {
    const {template} = state
    const {xxlBreakpointEnabled} = state.settings

    return {templating: template, props, xxlBreakpointEnabled}
}

export default connect(mapStateToProps)
